import { Link, useLocation, useSearchParams } from "react-router";
import { CourseInbox } from "@/components/inbox/CourseInbox";
import { Button } from "@/components/ui/button";
import { AnnouncementsPage } from "@/pages/AnnouncementsPage";
import { useTenantPresentation } from "@/hooks/use-tenant-presentation";

type InboxShell = "admin" | "adminTeaching" | "instructor" | "student";

const WORKSPACE_LABEL: Record<InboxShell, string> = {
  admin: "Admin Portal",
  adminTeaching: "My Teaching",
  instructor: "Instructor",
  student: "My Learning",
};

/**
 * Course conversations, with the institution feed still available.
 *
 * The admin shell's inbox (`/admin/inbox`) is the one institution notices
 * destination: every notice, Academy-wide and course, with the compose that
 * posts them (`?notice=` opens one exactly, `?compose=notice` focuses compose,
 * `?course=` narrows the feed and the audience). A seat inbox keeps its
 * conversations and a read-only Academy-wide feed at `?view=notices`.
 */
export function InboxPage({ shell }: { shell: InboxShell }) {
  const { name: tenantName } = useTenantPresentation();
  const [params] = useSearchParams();
  const location = useLocation();
  if (shell !== "admin" && params.get("view") !== "notices")
    return <CourseInbox />;
  const admin = shell === "admin";
  return (
    <AnnouncementsPage
      scope={admin ? undefined : "academy"}
      presentation="inbox"
      compose={admin}
      eyebrow={`${tenantName} · ${WORKSPACE_LABEL[shell]}`}
      action={admin ? undefined : (
        <Button variant="ghost" asChild>
          <Link to={location.pathname}>Back to conversations</Link>
        </Button>
      )}
    />
  );
}
